import './App.scss';
import { Main } from './components/Main/Main';


export const App = () => (
  <section className="App">
    <Main />
  </section>
);